// PWA standalone check (cached at module level)
export const isPWAStandalone = typeof window !== 'undefined' && (
    window.navigator.standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches
)

// Map subdomain keys to SPA paths
const PATH_MAPPINGS = {
    construction: '/construction',
    architecture: '/architecture',
    windows: '/windows',
    roofing: '/roofing'
}

export const getSubdomainUrl = (subdomain, path = '') => {
    const isProd = import.meta.env.PROD
    const BASE_DOMAIN = 'jdrivero.com'

    // In PWA standalone mode, always use SPA paths to stay same-origin (no iOS URL bar)
    if (isPWAStandalone || !isProd) {
        if (subdomain === 'home') return path || '/'
        return `${PATH_MAPPINGS[subdomain] || '/'}${path}`
    }

    // Production browser: use subdomains
    if (subdomain === 'home') return `https://${BASE_DOMAIN}${path}`
    return `https://${subdomain}.${BASE_DOMAIN}${path}`
}

// Detect current business unit from hostname or pathname
export const getCurrentBU = () => {
    const hostname = window.location.hostname
    const pathname = window.location.pathname
    const subdomain = hostname.split('.')[0]

    // Check subdomain first (production subdomains)
    const buKeys = ['architecture', 'construction', 'windows', 'roofing']
    if (buKeys.includes(subdomain)) return subdomain

    // Check pathname (PWA standalone or dev paths)
    const pathSegment = pathname.split('/')[1]
    if (pathSegment === 'impact-windows') return 'windows'
    if (buKeys.includes(pathSegment)) return pathSegment

    return 'main'
}
